module.exports = __webpack_public_path__ + "static/media/floor_ew.4ab8fe8c.png";